import Link from "next/link";
import { useTranslations } from "next-intl";
import type { HTMLAttributes } from "react";
import { Img } from "@/components/image";
import { strapiUrl } from "@/lib/strapi";
import { cn } from "@/lib/utils";
import type { LastAddedListItemType } from "../../types/last-added.type";

type LastCateringItemProps = HTMLAttributes<HTMLDivElement> & {
  data: LastAddedListItemType & { logoUrl?: string };
};

export const CateringCarouselItem = ({
  data,
  ...props
}: LastCateringItemProps) => {
  const t = useTranslations("staticBuilder");
  return (
    <div
      className={cn(
        "flex h-22 items-center rounded-xl border border-input bg-white",
        props.className,
      )}
      key={data.id} // Ensure each item has a unique key
    >
      <div className="flex h-full w-24 items-center justify-center border-input border-r p-2">
        {data.logo.url && (
          <Img
            src={data.logoUrl || ""}
            width={72}
            height={72}
            alt={data.name || ""}
          />
        )}
      </div>
      <div className="pr-8 pl-6">
        <h4 className="whitespace-nowrap font-medium text-2xl">{data.name}</h4>
        {data.url && (
          <Link
            href={data.url}
            title={data.name}
            className="underline-offset-[5px] hover:underline"
          >
            {t("see_catering")}
          </Link>
        )}
      </div>
    </div>
  );
};
